import $ from 'jquery';
import BaseSliderView from './BaseSliderView';

export default BaseSliderView.extend({

    events: {
        'click .js-slider-forward': 'onForwardClick',
        'click .js-slider-backward': 'onBackwardClick'
    },

    selectors: {
        elements: '.image-preload-icon',
        container: '.slider-content',
        controls: {
            forward: '.slider-arrow-right',
            backward: '.slider-arrow-left'
        }
    },

    /**
     * @type {$}
     */
    $elements: null,

    /**
     * @type {$}
     */
    $container: null,

    /**
     * @type {Boolean}
     */
    wasTouchMoved: false,

    localInitialize: function () {

        this.$elements = this.$(this.selectors.elements);
        this.$container = this.$(this.selectors.container);

        this.model.set({
            elementCount: this.$elements.length
        });

        /*
         check if there are are any products inside slider, and initialize all events only if so
         */
        if (this.model.get('elementCount') > 0) {

            this.$elements.appear($.proxy(this.onElementAppear, this));

            /*
             Setup other model properties
             */

            var itemNumber = this.$el.attr('data-item-number');

            if (itemNumber) {
                this.model.set({
                    maxElements: parseInt(itemNumber, 10)
                });
            }

            this.model.set({
                elementSize: this.getElementSize(),
                minOffset: this.getCurrentOffset(),
                currentOffset: this.getCurrentOffset()
            });

            this.model.updateMaxOffset();

            this.setContainerSize(this.model.get('elementSize') * this.model.get('elementCount'));

            this.listenTo(this.model, 'change:currentOffset', this.handleControlsVisibility);
            this.listenTo(this.model, 'change:currentOffset', this.positionContainer);

            if (this.model.get('elementCount') > this.model.get('maxElements')) {
                this.$container.on('touchstart.slider-nav', $.proxy(this.onTouchStart, this));
            }
        } else {
            /*
            If slider is empty, hide it, there is really no point of keeping it taking space
             */
            this.$el.addClass('is-hidden');
        }

        this.handleControlsVisibility();
    },

    onForwardClick: function (event) {
        event.preventDefault();
        this.model.move(this.model.directions.forward);
    },

    onBackwardClick: function (event) {
        event.preventDefault();
        this.model.move(this.model.directions.backward);
    },

    handleControlsVisibility: function () {

        var method;

        if (this.model.isControlBackwardVisible()) {
            method = 'removeClass';
        } else {
            method = 'addClass';
        }

        this.$(this.selectors.controls.backward)[method]('is-invisible');

        if (this.model.isControlForwardVisible()) {
            method = 'removeClass';
        } else {
            method = 'addClass';
        }

        this.$(this.selectors.controls.forward)[method]('is-invisible');
    },

    /**
     * @param {Event} event
     */
    onElementAppear: function (event) {
        var $preloader = $(event.currentTarget);
        var $imageContainer = $preloader.find('.slider-article');
        var imagePath = $imageContainer.data('image');

        if (imagePath) {
            $('<img />').load(function () {
                $preloader.css('background-image', 'none');
            }).attr('src', imagePath);

            $imageContainer.css('background-image', 'url(' + imagePath + ')');
        }
    },

    onTouchStart: function (event) {
        this.setStartTouch(event);

        this.$container.on('touchmove.slider-nav', $.proxy(this.onTouchMove, this));
        this.$container.on('touchend.slider-nav', $.proxy(this.onTouchEnd, this));
    },

    onTouchMove: function (event) {

        this.setCurrentTouch(event);

        var deltaMain;
        var deltaAuxilary;

        deltaMain = this.model.get('touchStartMainAxis') - this.model.get('touchCurrentMainAxis');
        deltaAuxilary = this.model.get('touchStartAuxilaryAxis') - this.model.get('touchCurrentAuxilaryAxis');

        if (Math.abs(deltaMain) * 1.2 >= Math.abs(deltaAuxilary)) {
            event.preventDefault();
        }

        if ((Math.abs(deltaAuxilary) > 15) && (Math.abs(deltaAuxilary) > Math.abs(deltaMain) * 2)) {
            this.$container.off('touchmove.slider-nav');

            return;
        }

        if (Math.abs(deltaMain) >= 1) {
            this.model.updateOffsetFromDelta(deltaMain);
        }

        this.wasTouchMoved = true;

    },

    onTouchEnd: function (event) {

        if (this.wasTouchMoved) {
            event.preventDefault();
            this.wasTouchMoved = false;
        }

        this.$container.off('touchmove.slider-nav');
        this.$container.off('touchend.slider-nav');
    },

    getCurrentOffset: function () {
        return this.$container.position().left;
    },

    getElementSize: function () {
        // noinspection JSValidateTypes
        return this.$elements.first().outerWidth(true);
    },

    setContainerSize: function (value) {
        this.$container.width(value);
    },

    positionContainer: function () {
        this.$container.css('left', this.model.get('currentOffset') + 'px');
    },

    setStartTouch: function (event) {
        this.model.set({
            touchStartMainAxis: event.originalEvent.touches[0].pageX,
            touchStartAuxilaryAxis: event.originalEvent.touches[0].pageY,
            touchStartOffset: this.model.get('currentOffset')
        });
    },

    setCurrentTouch: function (event) {
        this.model.set({
            touchCurrentMainAxis: event.originalEvent.touches[0].pageX,
            touchCurrentAuxilaryAxis: event.originalEvent.touches[0].pageY
        });
    }

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/sliders/HorizontalSliderView.js
 **/